export const SUPPORT_PHONE = "+55 (33) 98444-7201";
export const SUPPORT_PHONE_HREF = `tel:+${SUPPORT_PHONE.replace(/\D/g, "")}`;
